import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    back: translate({ id: 'global.back' }),
    cancel: translate({ id: 'global.cancel' }),
    add: (recurrenceAlreadySet: boolean, recurrence: string) => {
      if (recurrenceAlreadySet)
        return translate({
          id: 'setup.traffic.trafficProfile.openBtnText',
          values: { recurrence },
        })
      return translate({ id: 'setup.traffic.trafficProfile.createBtnTextNoDate' })
    },
    setRecurrenceTranslation: translate({ id: 'recurrenceSelector.footer.button.setRecurrence' }),
    openExistingTranslation: translate({ id: 'recurrenceSelector.footer.button.openExisting' }),
    trafficProfile: translate({ id: 'setup.traffic.trafficProfile.title' }),
  }))

  return api
}
